import api from '@/apis'

export const fetchList = params => api.get(`/workers`, { params })
export const findById = id => api.get(`/workers/${id}`)
export const setActiveState = (id, isActive) => api.put(`/workers/${id}/set_active`, { isActive })
export const changeBalance = (id, record) => api.put(`/workers/${id}/change_balance`, record)
export const setIsVeteran = (id, isVeteran) => api.put(`/workers/${id}/set_vseteran`, { isVeteran })
export const workersDesMargin = (id, record) => api.post(`/workers/${id}/des_margin`, record)
